// Lighthouse 6 no longer sends extensions.category; with APP_DEBUG=true every error carries extensions (file, trace)
export function errorKind ( error )
{
    let extensions = error.extensions || {};
    if ( extensions.validation )
    {
        return 'validation';
    }
    if ( extensions.guards || error.message === 'Unauthenticated.' )
    {
        return 'authentication';
    }
    if ( error.message === 'Unauthorized.' || error.message === 'This action is unauthorized.' )
    {
        return 'authorization';
    }
    if ( !error.path )
    {
        return 'graphql';
    }
    if ( error.message === 'Internal server error' )
    {
        return 'internal';
    }
    return 'generic';
}
